import { useState } from 'react';

import { useSnackbar } from "notistack";

import {
    BillingInfoContainer,
} from '../../../Styles/Billings/checkoutStyles';

import { useBillingHook } from '../../../Hooks/Billings/billingHooks';

import { CheckoutBillingInfoInterface } from '../../../Models/Common/CustomViewsInterfaces';

import RequiredParametersHelper from '../../../Utilities/Helpers/RequiredParametersHelper';
import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';
import RequiredFieldHelper from '../../../Utilities/Helpers/RequiredFieldHelper';

import { BuyLicenseField, InvoiceField, BillingDetailsField, BillingAddressField, CheckoutDataField } from '../../../Utilities/Enums/ParametersEnum';
import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';

import CustomStepContent from '../../../CustomViews/Elements/CustomStepper/CustomStepContent';

import FormTextField from '../../../CustomViews/Elements/FormTextField';
import AutoCompleteDropdown from '../../../CustomViews/Elements/AutoCompleteDropdown';

export default function BillingInfo(props: CheckoutBillingInfoInterface) {
    let requiredFields = RequiredParametersHelper.checkoutBillingInfo();
    const { enqueueSnackbar } = useSnackbar();

    //Use States
    let [errorMessages, setErrorMessages]: any = useState({});
    const [queryStr, setQueryStr] = useState({
        pageSize: 10,
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

    const q_queryKey = [CachingEnum.BILLINGS, queryStr];
    const { DropdownData, dropdownFetchStatus } = useBillingHook(q_queryKey, queryStr, false);
    
    //Variables
    const contPersonProps = {
        name: BillingDetailsField.CONTACT_PERSON,
        title: 'Name',
        fieldValue: props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.CONTACT_PERSON] ?? "",
        type: 'text',
        fieldClassName: 'span2Field',
        required: requiredFields?.find((field: any) => field.keyName == CheckoutDataField.BILLING_DETAILS)?.fields?.find((f: any) => f.keyName == BillingDetailsField.CONTACT_PERSON)?.keyName != null,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {
            if(props?.setcheckoutFormData) {
                props.setcheckoutFormData((prev: any) => ({
                    ...prev, 
                    [CheckoutDataField.BILLING_DETAILS]: {
                        ...prev?.[CheckoutDataField.BILLING_DETAILS],
                        [BillingDetailsField.CONTACT_PERSON]: selectedValue,
                    }
                }));
            }
        },
    },
        contPhoneProps = {
            name: BillingDetailsField.CONTACT_PHONE,
            title: 'Contact Number',
            fieldValue: props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.CONTACT_PHONE] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == CheckoutDataField.BILLING_DETAILS)?.fields?.find((f: any) => f.keyName == BillingDetailsField.CONTACT_PHONE)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(props?.setcheckoutFormData) {
                    props.setcheckoutFormData((prev: any) => ({
                        ...prev, 
                        [CheckoutDataField.BILLING_DETAILS]: {
                            ...prev?.[CheckoutDataField.BILLING_DETAILS],
                            [BillingDetailsField.CONTACT_PHONE]: selectedValue,
                        }
                    }));
                }
            },
        },
        contEmailAddressProps = {
            name: BillingDetailsField.EMAIL,
            title: 'Email',
            fieldValue: props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.EMAIL] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == CheckoutDataField.BILLING_DETAILS)?.fields?.find((f: any) => f.keyName == BillingDetailsField.EMAIL)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(props?.setcheckoutFormData) {
                    props.setcheckoutFormData((prev: any) => ({
                        ...prev, 
                        [CheckoutDataField.BILLING_DETAILS]: {
                            ...prev?.[CheckoutDataField.BILLING_DETAILS],
                            [BillingDetailsField.EMAIL]: selectedValue,
                        }
                    }));
                }
            },
        },
        billingAddressProps = {
            name: BillingAddressField.STREET_ADDRESS,
            title: 'Billing Address',
            fieldValue: props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.STREET_ADDRESS] ?? "",
            type: 'text',
            fieldClassName: 'span2Field',
            required: requiredFields?.find((field: any) => field.keyName == CheckoutDataField.BILLING_DETAILS)?.fields?.find((f: any) => f.keyName == BillingDetailsField.ADDRESS)?.fields?.find((f: any) => f.keyName == BillingAddressField.STREET_ADDRESS)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                let _checkoutFormData = {
                    ...props?.checkoutFormData,
                    [CheckoutDataField.BILLING_DETAILS]: {
                        ...props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS],
                        [BillingDetailsField.ADDRESS]: {
                            ...props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS],
                            [BillingAddressField.STREET_ADDRESS]: selectedValue,
                        },
                    },
                };

                updateAddress(_checkoutFormData);
            },
        },
        cityProps = {
            name: BillingAddressField.CITY,
            title: 'City',
            fieldValue: props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.CITY] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == CheckoutDataField.BILLING_DETAILS)?.fields?.find((f: any) => f.keyName == BillingDetailsField.ADDRESS)?.fields?.find((f: any) => f.keyName == BillingAddressField.CITY)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                let _checkoutFormData = {
                    ...props?.checkoutFormData,
                    [CheckoutDataField.BILLING_DETAILS]: {
                        ...props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS],
                        [BillingDetailsField.ADDRESS]: {
                            ...props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS],
                            [BillingAddressField.CITY]: selectedValue,
                        },
                    },
                };

                updateAddress(_checkoutFormData);
            },
        },
        stateProps = {
            name: BillingAddressField.STATE,
            title: 'State',
            fieldValue: props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.STATE] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == CheckoutDataField.BILLING_DETAILS)?.fields?.find((f: any) => f.keyName == BillingDetailsField.ADDRESS)?.fields?.find((f: any) => f.keyName == BillingAddressField.STATE)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                let _checkoutFormData = {
                    ...props?.checkoutFormData,
                    [CheckoutDataField.BILLING_DETAILS]: {
                        ...props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS],
                        [BillingDetailsField.ADDRESS]: {
                            ...props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS],
                            [BillingAddressField.STATE]: selectedValue,
                        },
                    },
                };

                updateAddress(_checkoutFormData);
            },
        },
        postalCodeProps = {
            name: BillingAddressField.ZIP_CODE,
            title: 'Postal Code',
            fieldValue: props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.ZIP_CODE] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == CheckoutDataField.BILLING_DETAILS)?.fields?.find((f: any) => f.keyName == BillingDetailsField.ADDRESS)?.fields?.find((f: any) => f.keyName == BillingAddressField.ZIP_CODE)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                let _checkoutFormData = {
                    ...props?.checkoutFormData,
                    [CheckoutDataField.BILLING_DETAILS]: {
                        ...props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS],
                        [BillingDetailsField.ADDRESS]: {
                            ...props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS],
                            [BillingAddressField.ZIP_CODE]: selectedValue,
                        },
                    },
                };

                updateAddress(_checkoutFormData);
            },
        },
        countryProps = {
            name: BillingAddressField.COUNTRY,
            title: 'Country',
            fieldValue: props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.COUNTRY] ?? "",
            options: DropdownData[CachingEnum.COUNTRY_LIST] ?? [],
            isLoadingDropdown: dropdownFetchStatus,
            required: requiredFields?.find((field: any) => field.keyName == CheckoutDataField.BILLING_DETAILS)?.fields?.find((f: any) => f.keyName == BillingDetailsField.ADDRESS)?.fields?.find((f: any) => f.keyName == BillingAddressField.COUNTRY)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                let _checkoutFormData = {
                    ...props?.checkoutFormData,
                    [CheckoutDataField.BILLING_DETAILS]: {
                        ...props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS],
                        [BillingDetailsField.ADDRESS]: {
                            ...props?.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS],
                            [BillingAddressField.COUNTRY]: selectedValue?.id ?? '',
                        },
                    },
                };

                updateAddress(_checkoutFormData);
            },
        };

    //Event Handlers
    const updateAddress = async (_checkoutFormData: any) => {
        let _streetAddress = _checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.STREET_ADDRESS] ?? "";
        let _city = _checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.CITY] ?? "";
        let _state = _checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.STATE] ?? "";
        let _zipCode = _checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.ZIP_CODE] ?? "";
        let _country = DropdownData[CachingEnum.COUNTRY_LIST]?.find((x: any) => x.id == (_checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.COUNTRY] ?? 0))?.name ?? "";
        let _fullAddress = _streetAddress ?? "";

        _fullAddress += _city ? " " + _city : "";
        _fullAddress += _state ? " " + _state : "";
        _fullAddress += _zipCode ? " " + _zipCode : "";
        _fullAddress += _country ? " " + _country : "";

        if(props?.setcheckoutFormData) {
            props.setcheckoutFormData({
                ..._checkoutFormData,
                [CheckoutDataField.BILLING_DETAILS]: {
                    ..._checkoutFormData?.[CheckoutDataField.BILLING_DETAILS],
                    [BillingDetailsField.ADDRESS]: {
                        ..._checkoutFormData?.[CheckoutDataField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS],
                        [BillingAddressField.FULL_ADDRESS]: _fullAddress,
                    },
                },
            });
        }
    }

    return <CustomStepContent
            stepHeader={"Billing Information"}
            stepSubHeader={"Please fill all information below"}
            children={<BillingInfoContainer>
                <FormTextField {...contPersonProps} />

                <FormTextField {...contPhoneProps} />
                <FormTextField {...contEmailAddressProps} />

                <FormTextField {...billingAddressProps} />

                <FormTextField {...cityProps} />
                <FormTextField {...stateProps} />

                <FormTextField {...postalCodeProps} />
                <AutoCompleteDropdown {...countryProps} />
            </BillingInfoContainer>}
            stepperItems={DropdownData[CachingEnum.CHECKOUT_STEP_LIST] ?? []}
            selectedStep={props?.selectedStep}
            setselectedStep={props?.setselectedStep}
            validateStep={() =>{
                let _validateForm = RequiredFieldHelper.validateForm(requiredFields, props?.checkoutFormData, errorMessages, setErrorMessages, enqueueSnackbar);


                return !_validateForm?.hasError;
            }} />
}
